import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import Cell from './cell';
import Header from './header';
import Headers from './headers';
import { TableTreeContext } from './internal/context';
import Row from './row';
import Rows from './rows';
export default class TableTree extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      columnWidths: []
    });
    _defineProperty(this, "setColumnWidth", (columnIndex, width) => {
      const {
        columnWidths
      } = this.state;
      if (width === columnWidths[columnIndex]) {
        return;
      }
      columnWidths[columnIndex] = width;
      this.setState({
        columnWidths
      });
    });
    _defineProperty(this, "getColumnWidth", columnIndex => {
      return this.state && this.state.columnWidths[columnIndex] || null;
    });
  }
  componentDidMount() {
    const widths = this.props.columnWidths;
    if (widths) {
      this.setState({
        columnWidths: widths
      }); // eslint-disable-line
    }
  }

  render() {
    const {
      items,
      shouldExpandOnClick,
      headers,
      columns,
      columnWidths = [],
      mainColumnForExpandCollapseLabel
    } = this.props;
    const heads = headers && /*#__PURE__*/React.createElement(Headers, null, headers.map((header, index) =>
    /*#__PURE__*/
    // eslint-disable-next-line react/no-array-index-key
    React.createElement(Header, {
      key: index,
      columnIndex: index,
      width: columnWidths[index]
    }, header)));
    let rows = null;
    if (columns && items) {
      rows = /*#__PURE__*/React.createElement(Rows, {
        items: items,
        render: ({
          id,
          children,
          hasChildren,
          content
        }) => {
          return /*#__PURE__*/React.createElement(Row, {
            itemId: id,
            items: children,
            hasChildren: hasChildren,
            shouldExpandOnClick: shouldExpandOnClick,
            mainColumnForExpandCollapseLabel: mainColumnForExpandCollapseLabel
          }, columns.map((CellContent, index) => /*#__PURE__*/React.createElement(Cell
          // eslint-disable-next-line react/no-array-index-key
          , {
            key: index,
            columnIndex: index,
            width: columnWidths[index]
          }, /*#__PURE__*/React.createElement(CellContent, content))));
        }
      });
    }
    return /*#__PURE__*/React.createElement(TableTreeContext.Provider, {
      value: {
        setColumnWidth: this.setColumnWidth,
        getColumnWidth: this.getColumnWidth
      }
    }, /*#__PURE__*/React.createElement("div", {
      role: "treegrid",
      "aria-readonly": true
    }, heads, rows, this.props.children));
  }
}